import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Section, {
  ContactSection,
  HourSection,
  PriceSection,
} from "../components/section"
import { Flex } from "@chakra-ui/react"
import { graphql } from "gatsby"

const IndexPage = ({data}) => {

  const manPrices = [
    { name: "Coupe simple", value: "28€" },
    { name: "Coupe pas simple", value: "28€" },
    { name: "Coupe", value: "28€" },
    { name: "Coupe simple", value: "28€" },
    { name: "Coupe simple", value: "28€" },
  ]
  const womanPrices = [
    { name: "Coupe simple", value: "128€" },
    { name: "Coupe avec shampoing", value: "128€" },
    { name: "Coupe simple", value: "128€" },
    { name: "Coupe simple", value: "128€" },
    { name: "Coupe simple", value: "128€" },
  ]

  const hours = [
    { name: "Lundi", value: "Fermé" },
    { name: "Mardi", value: "9h-18h30" },
    { name: "Mercredi", value: "9h-18h30" },
    { name: "Jeudi", value: "9h-18h30" },
    { name: "Vendredi", value: "9h-18h30" },
    { name: "Samedi", value: "9h-18h00" },
    { name: "Dimanche", value: "Fermé" },
  ]
  return (
    <Layout data={data}>
      <Seo title="Home" />
      <Section id="tarifs" title="Nos tarifs">
        <Flex wrap="wrap" justify="space-around">
          <PriceSection title="Masculin" prices={manPrices} />
          <PriceSection title="Féminin" prices={womanPrices} />
        </Flex>
      </Section>

      <Section id="horaires" variant="black" title="Nos horaires">
        <HourSection hours={hours} />
      </Section>

      <Section id="retrouvez" title="Nous retrouver">
        <ContactSection
          phone={data.site.siteMetadata.phone}
          address={data.site.siteMetadata.address}
        />
      </Section>
    </Layout>
  )
}

export const query = graphql`
  query HomePageQuery {
    site {
      siteMetadata {
        title
        phone
        address
      }
    }
  }
`

export default IndexPage
